import type { AxiosError } from "axios";

/** Human-readable message from instrakt / Spring error bodies or axios failures. */
export function extractApiErrorMessage(
  err: unknown,
  fallback = "Request failed."
): string {
  if (err instanceof Error && err.message && err.message !== "[object Object]") {
    return err.message;
  }
  const ax = err as AxiosError<{ message?: string; error?: string }>;
  if (ax?.response?.data?.message) {
    return ax.response.data.message;
  }
  if (typeof ax?.response?.data === "string") {
    return ax.response.data;
  }
  if (ax?.message) {
    return ax.message;
  }
  return fallback;
}

export function springErrorMessage(
  data: unknown,
  status: number,
  fallback: string
): string {
  if (data && typeof data === "object" && "message" in data) {
    const msg = (data as { message?: string }).message;
    if (msg) return msg;
  }
  if (status === 404) {
    return "API not found — rebuild instrakt with the RAG module and use profile local.";
  }
  if (status === 403) {
    return "Org Admin role is required.";
  }
  return fallback;
}
